import "@fortawesome/fontawesome-free/css/all.css";
import "@/assets/fontawesome-pro-5.15.4-web/css/all.css";
import Vue from "vue";
import store from "./store";
import router from "./router/";
import App from "./App.vue";
import "@/plugins/filters";
import vuetify from "./plugins/vuetify";
import "@/styles/index.scss";
import OpenLinkInTab from "./plugins/OpenLinkInTab";
import BeSkeletonLoader from "@/components/BeSkeletonLoader";
import PageTitle from "@/components/PageTitle";
import ellipsis from "@/plugins/ellipses/main";
import VueI18n from "vue-i18n";
import messages from "@/i18n/index.js";
import VueApexCharts from "vue-apexcharts";
import SharedComponents from "shared-components";

Vue.component("BeSkeletonLoader", BeSkeletonLoader);
Vue.component("PageTitle", PageTitle);
Vue.use(OpenLinkInTab);
Vue.use(ellipsis);
Vue.use(VueI18n);
Vue.use(VueApexCharts);
Vue.use(SharedComponents);

Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;
Vue.config.silent = true;

export const i18n = new VueI18n({
  locale: localStorage.getItem("userLang") ?? "pt-BR",
  fallbackLocale: "pt-BR",
  messages,
  silentTranslationWarn: process.env.NODE_ENV === "production",
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
